export const wfnsItems = [
  {
    name: "Grade I",
    description: "GCS 15, Motor Deficit Absent",
    value: "I",
    interpretation: ""
  },
  {
    name: "Grade II",
    description: "GCS 14 - 13, Motor Deficit Absent",
    value: "II",
    interpretation: ""
  },
  {
    name: "Grade III",
    description: "GCS 14 - 13, Motor Deficit Present",
    value: "III",
    interpretation: ""
  },
  {
    name: "Grade IV",
    description: "GCS 12 - 7, Motor Deficit Present or Absent",
    value: "IV",
    interpretation: ""
  },
  {
    name: "Grade V",
    description: "GCS 6 - 3, Motor Deficit Present or Absent",
    value: "V",
    interpretation: ""
  }
]